const styles = {
  CustomSortContainer: {
    display: "flex",
    flexDirection: "row",
  },
} as const;

export default styles;
